/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaptureCompletePayload
 */
export interface CaptureCompletePayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: CaptureCompletePayloadTypeEnum;
    /**
     * 
     */
    captureId: string;
    /**
     * 
     */
    weightGrams?: number | null;
    /**
     * 
     */
    lengthMm?: number | null;
    /**
     * 
     */
    ok: boolean;
    /**
     * 
     */
    error?: string | null;
}


/**
 * @export
 */
export const CaptureCompletePayloadTypeEnum = {
    CaptureComplete: 'capture_complete',
} as const;
export type CaptureCompletePayloadTypeEnum = typeof CaptureCompletePayloadTypeEnum[keyof typeof CaptureCompletePayloadTypeEnum];


/**
 * Check if a given object implements the CaptureCompletePayload interface.
 */
export function instanceOfCaptureCompletePayload(value: object): value is CaptureCompletePayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'capture_complete') return false;
    
    if ((!('captureId' in (value as Record<string, any>)) && !('capture_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureId'] === undefined && (value as Record<string, any>)['capture_id'] === undefined)) return false;
    if (!('ok' in value) || value['ok'] === undefined) return false;
    return true;
}

export function CaptureCompletePayloadFromJSON(json: any): CaptureCompletePayload {
    return CaptureCompletePayloadFromJSONTyped(json, false);
}

export function CaptureCompletePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaptureCompletePayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'captureId': json['capture_id'],
        'weightGrams': json['weight_grams'] === undefined ? undefined : json['weight_grams'] === null ? null : json['weight_grams'],
        'lengthMm': json['length_mm'] === undefined ? undefined : json['length_mm'] === null ? null : json['length_mm'],
        'ok': json['ok'],
        'error': json['error'] === undefined ? undefined : json['error'] === null ? null : json['error'],
    };
}

export function CaptureCompletePayloadToJSON(json: any): CaptureCompletePayload {
    return CaptureCompletePayloadToJSONTyped(json, false);
}

export function CaptureCompletePayloadToJSONTyped(value?: CaptureCompletePayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'capture_id': value['captureId'],
        'weight_grams': value['weightGrams'],
        'length_mm': value['lengthMm'],
        'ok': value['ok'],
        'error': value['error'],
    };
}

